<script lang="ts">
  import { t } from "../../../core";
  import AsideBlock from "./aside-blocks/AsideBlock.svelte";
  import TwoColumns from "../TwoColumns.svelte";
  import type { IPageData } from "../../../core/types";
  import ChangePassword from "./aside-blocks/ChangePassword.svelte";
  import SendEmail from "./aside-blocks/SendEmail.svelte";

  interface IMyProfilePage extends IPageData {
    customerData: {
      address: string;
      city: string;
      email: string;
      name: string;
      phoneNumber: string;
      zipCode: string;
    };
    constructionData: {
      address: string;
      caseNumber: string;
      city: string;
      registrationNumber: string;
      zipCode: string;
    };
    isChangeUserInformationEmailSendingAllowed: boolean;
    isChangePasswordAllowed: boolean;
  }

  export let data: IMyProfilePage;
</script>

<TwoColumns>
  <div class="g-centered">
    <h1 class="title">{data.title}</h1>

    {#if data?.customerData}
      <div class="my-profile__row">
        <div class="my-profile__col">
          <div class="my-profile__subtitle">
            {t("MyProfile.General.CaseNumber")}
          </div>
          <div class="my-profile__desc">
            {data?.constructionData?.caseNumber}
          </div>
        </div>
      </div>

      <div class="my-profile__row">
        <div class="my-profile__col">
          <div class="my-profile__subtitle">
            {t("MyProfile.General.CurrentAddress")}
          </div>
          <div class="my-profile__desc">
            {data?.customerData?.name}<br />
            {data?.customerData?.address}<br />
            {data?.customerData?.zipCode}
            {data?.customerData?.city}
          </div>
        </div>
        <div class="my-profile__col">
          <div class="my-profile__subtitle">{t("MyProfile.General.Email")}</div>
          <div class="my-profile__desc">{data?.customerData?.email}</div>

          <div class="my-profile__subtitle">{t("MyProfile.General.Phone")}</div>
          <div class="my-profile__desc">{data?.customerData?.phoneNumber}</div>
        </div>
      </div>

      <div class="my-profile__row">
        <div class="my-profile__col">
          <div class="my-profile__subtitle">
            {t("MyProfile.General.ConstructionAddress")}
          </div>
          <div class="my-profile__desc">
            {data?.constructionData?.address}<br />
            {data?.constructionData?.zipCode}
            {data?.constructionData?.city}<br />
            <br />
            {t("MyProfile.General.MatrNr")}
            &nbsp;{data?.constructionData?.registrationNumber}
          </div>
        </div>
      </div>
    {/if}
  </div>

  <slot />

  <div slot="aside">
    {#if data?.isChangeUserInformationEmailSendingAllowed}
      <AsideBlock
        title={t("MyProfile.SendEmail.Title")}
        desc={t("MyProfile.SendEmail.Desc")}
        buttonText={t("MyProfile.SendEmail.ButtonText")}
      >
        <SendEmail />
      </AsideBlock>
    {/if}
    {#if data?.isChangePasswordAllowed}
    <AsideBlock
      title={t("MyProfile.ChangePassword.Title")}
      buttonText={t("MyProfile.ChangePassword.ButtonText")}
    >
      <ChangePassword />
    </AsideBlock>
    {/if}
  </div>
</TwoColumns>

<style lang="scss">
  .title {
    @include h1;
    margin-bottom: 36px;
  }

  .my-profile {
    &__row {
      padding-bottom: 20px;
      margin-bottom: 20px;
      display: grid;
      grid-template-columns: 1fr 1fr;

      &:not(:last-child) {
        border-bottom: 1px solid $contrast-color;
      }
    }

    &__subtitle {
      @include h2;
      margin-bottom: 12px;
    }

    &__desc {
      margin-bottom: 30px;
    }
  }
</style>
